import { Session } from "../../js/scripts/session.js";

export const FormFilter = {
    DataInicio: GetDataInicio(),
    DataFim: new Date,
    Segmento: GetSegmento(),
    ServiceId: ""
 }
 
 function GetDataInicio (){
    const minInicio = new Date;
    minInicio.setMonth(minInicio.getMonth() - 4);
    return minInicio;
 }

 function GetSegmento (){
   if (Session && Session.VnoId == 'GVT')
      return 1;
   if (Session && Session.VnoId == 'ATC')
      return 0;

   return -1;
 }